import { useEffect, useState } from 'react';
import IconMoney from '../../assets/icons/IconMoney';
import { useDebtResult } from '../../contexts/DebtContext';
import { getDebtAmount, pricesHelper } from '../../utils/paymentsHelper';
import { DetailModal } from '../DetailModal';
import { useLocation } from 'react-router-dom';
import { ROUTES_PATH } from '../../constants';
import {
  DetailOverlay,
  HeaderContainer,
  HeaderMenu,
  HeaderSubMenuOne,
  HeaderSubMenuTwo,
  PendingDebtTitle,
  PriceDetailWrapper,
  SubMenuPrice,
  Price,
  Currency,
  DetailInformation,
  HeaderTexts,
  MoneyWrapper,
  ContainerBackgroundMenu,
  HeaderMenuRow,
  HeaderInformationText,
} from './CustomerHeaderStyledComponents';
import {
  TextBold,
  TextRegular,
} from '../../styles/GlobalStyledComponents';
import { useUserResult } from '../../contexts/UserContext';
import { nameDisplayHelper } from '../../utils/nameDisplayHelper';
import IconInformation from '../../assets/icons/IconInformation';
import { usePaymentSelected } from '../../contexts/PaymentSelectedContext';
import {
  PaymentPlanData,
} from '../../interfaces/PaymentPlan';
import { DetailPaymentPlan } from '../DetailPaymentPlan';

const CustomerHeader = () => {
  const { debtResult } = useDebtResult();
  const { userResult } = useUserResult();
  const { coPaymentSelected } = usePaymentSelected();
  const pathName = useLocation().pathname;
  const [modalOpened, setModalOpened] = useState<boolean>(false);
  const [amount, setAmount] = useState<number>(0);
  const [isCo, setIsCo] = useState<boolean>(false);
  const [paymentPlan, setPaymentPlan] = useState<PaymentPlanData[]>([]);
  const [isPaymentPlan, setIsPaymentPlan] = useState<boolean>(false);
  const [userName, setUserName] = useState<string>('');

  useEffect(() => {
    if (userResult?.name) {
      const newNameFormat = nameDisplayHelper(userResult?.name);
      setUserName(newNameFormat);
    }
  }, [userResult]);

  useEffect(() => {
    if (pathName.includes(ROUTES_PATH.ENTRY_CO)) {
      if (!isCo) {
        setIsCo(true);
      }
      getAmountInfo();
      if (debtResult) {
        if (
          coPaymentSelected &&
          coPaymentSelected.payment_plan &&
          coPaymentSelected.payment_plan.length > 0 &&
          !coPaymentSelected.allow_creation_payment_plan
        ) {
          setIsPaymentPlan(true);
          setPaymentPlan(coPaymentSelected.payment_plan);
        } else if (
          debtResult?.loans.length === 1 &&
          debtResult.loans[0].payment_plan &&
          debtResult.loans[0].payment_plan.length > 0 &&
          !debtResult?.loans[0].allow_creation_payment_plan
        ) {
          const loan = debtResult?.loans[0];
          if (loan && loan.payment_plan) {
            setIsPaymentPlan(true);
            setPaymentPlan(loan.payment_plan);
          } else {
            setIsPaymentPlan(false);
          }
        } else {
          setIsPaymentPlan(false);
        }
      }
    } else {
      setIsCo(false);
    }
  }, [pathName, coPaymentSelected]);

  const getAmountInfo = () => {
    if (debtResult) {
      const totalDebtAmount = getDebtAmount(debtResult!);
      if (debtResult.loans.length === 1) {
        setAmount(debtResult.loans[0].certified_debt || 0);
      } else if (debtResult.loans.length > 1) {
        if (coPaymentSelected) {
          const promotion = debtResult?.promotions.find(
            (promotion) => promotion.loan_id === coPaymentSelected.loan_id
          );
          const loanAmount = promotion
            ? promotion.amount + promotion.amount_excused
            : coPaymentSelected.certified_debt ?? 0;
          setAmount(loanAmount);
        } else if (totalDebtAmount) {
          setAmount(totalDebtAmount);
        }
      }
    }
  };

  return (
    <>
      {debtResult && (
        <>
          <DetailOverlay
            open={modalOpened}
            onClick={() => setModalOpened(false)}
            id="debt-detail-modal-background-close"
          />
          <HeaderContainer id="header-container">
            {debtResult && (
              <ContainerBackgroundMenu id="container-background-menu">
                <HeaderMenu id="header-menu">
                  <HeaderMenuRow id="header-menu-row">
                    <HeaderSubMenuOne id="header-sub-menu-one">
                      <HeaderTexts id="header-texts">
                        {userName && (
                          <>
                            <TextBold
                              fontSize={16}
                              lineHeight={22}
                              id="welcome-title"
                            >
                              Hola{' '}
                              <TextBold fontSize={16} lineHeight={22}>
                                {userName}
                              </TextBold>
                            </TextBold>
                            <TextRegular
                              fontSize={14}
                              color={'gray6'}
                              lineHeight={20}
                            >
                              {isCo
                                ? 'Ponte al día con tu deuda.'
                                : 'Completa aquí tu pago pendiente 😃'}
                            </TextRegular>
                          </>
                        )}
                      </HeaderTexts>
                    </HeaderSubMenuOne>
                    <HeaderSubMenuTwo $coStyles={isCo} id="header-sub-menu-two">
                      <MoneyWrapper id="header-money-wrapper">
                        <IconMoney />
                      </MoneyWrapper>
                      <PriceDetailWrapper id="header-price-detail-wrapper">
                        <PendingDebtTitle id="header-debt-title">
                          <TextRegular
                            fontSize={14}
                            color={'gray6'}
                            lineHeight={20}
                          >
                            {!isPaymentPlan
                              ? 'Pago pendiente'
                              : 'Acuerdo de pago pendiente'}
                          </TextRegular>
                        </PendingDebtTitle>
                        <SubMenuPrice id="header-sub-menu-price">
                          <Price
                            fontSize={18}
                            color={'gray0'}
                            id="header-price"
                          >
                            {!isCo &&
                              debtResult &&
                              pricesHelper(debtResult?.amount!)}
                            {isCo && amount && pricesHelper(amount)}{' '}
                            <Currency>€</Currency>
                          </Price>
                        </SubMenuPrice>
                      </PriceDetailWrapper>
                      <DetailInformation
                        onClick={() => setModalOpened(true)}
                        $coStyles={!isCo || (isCo && isPaymentPlan)}
                        id="header-open-debt-details-btn"
                      >
                        <IconInformation />
                      </DetailInformation>
                    </HeaderSubMenuTwo>
                  </HeaderMenuRow>
                  {isCo && (
                    <HeaderMenuRow id="header-co-menu-row">
                      <HeaderInformationText id="header-co-information-text">
                        {!isPaymentPlan && (
                          <TextRegular
                            fontSize={14}
                            color={'gray6'}
                            lineHeight={20}
                          >
                            Si abonas tu deuda pendiente,{' '}
                            <TextBold fontSize={14} color={'gray6'}>
                              paralizas la gestión judicial
                            </TextBold>
                            , evitas intereses extras, y tu deuda sale de los
                            ficheros de morosidad.
                          </TextRegular>
                        )}
                        {isPaymentPlan && (
                          <TextRegular
                            fontSize={14}
                            color={'gray6'}
                            lineHeight={20}
                          >
                            Tienes un{' '}
                            <TextBold
                              fontSize={14}
                              color={'gray6'}
                              lineHeight={20}
                            >
                              acuerdo vigente
                            </TextBold>
                            , te presentamos el resumen a continuación.
                          </TextRegular>
                        )}
                      </HeaderInformationText>
                    </HeaderMenuRow>
                  )}
                </HeaderMenu>
              </ContainerBackgroundMenu>
            )}
          </HeaderContainer>
        </>
      )}
      {modalOpened && !isCo && (
        <DetailModal close={() => setModalOpened(false)} />
      )}
      {modalOpened && isCo && isPaymentPlan && (
        <DetailPaymentPlan
          close={() => setModalOpened(false)}
          paymentPlan={paymentPlan}
        />
      )}
    </>
  );
};

export default CustomerHeader;
